<script lang="ts">
	import { get } from "svelte/store";
	import Router, { replace } from "svelte-spa-router";
	import { wrap } from "svelte-spa-router/wrap";
	import StoryNew from "./book/story/StoryNew.svelte";
	import StoryRead from "./book/story/StoryRead.svelte";
	import DarkTaleNew from "./book/darktale/DarkTaleNew.svelte";
	import DarkTaleRead from "./book/darktale/DarkTaleRead.svelte";
	import ChristmasNew from "./book/christmas/ChristmasNew.svelte";
	import ViewPresentationNewRoute from "./lib/ViewPresentationNewRoute.svelte";
	import ViewPresentationRoute from "./lib/ViewPresentationRoute.svelte";
	import PresentationsShell from "./lib/PresentationsShell.svelte";
	import AddSuggestionShell from "./lib/AddSuggestionShell.svelte";
	import ImprintShell from "./lib/ImprintShell.svelte";
	import PrivacyShell from "./lib/PrivacyShell.svelte";
	import NewPresentationShell from "./lib/NewPresentationShell.svelte";
	import ManageSuggestionsShell from "./lib/ManageSuggestionsShell.svelte";
	import PublishPresentationRoute from "./lib/PublishPresentationRoute.svelte";
	import Toaster from "./lib/Toaster.svelte";
	import { isLoggedIn } from "./store/loginV2";

	const onLoggedOut = "/";
	const requireLogin = [
		async () => {
			if (get(isLoggedIn)) return true;
			replace(onLoggedOut);
			return false;
		},
	];

	const routes = {
		"/xmas/new": wrap({
			component: ChristmasNew,
			conditions: requireLogin,
		}),
		"/story/new": wrap({
			component: StoryNew,
			conditions: requireLogin,
		}),
		"/story/read/:id": StoryRead,
		"/dark-tales/new": wrap({
			component: DarkTaleNew,
			conditions: requireLogin,
		}),
		"/dark-tales/read/:id": DarkTaleRead,
		"/view/:id/new": ViewPresentationNewRoute,
		"/view/:id": ViewPresentationRoute,
		"/new-presentation": wrap({
			component: NewPresentationShell,
			conditions: requireLogin,
		}),
		"/list-suggestions": wrap({
			component: ManageSuggestionsShell,
			conditions: requireLogin,
		}),
		"/publish-presentation/:id": wrap({
			component: PublishPresentationRoute,
			conditions: requireLogin,
		}),
		"/add-suggestion": AddSuggestionShell,
		"/imprint": ImprintShell,
		"/privacy": PrivacyShell,
		"/": PresentationsShell,
		"*": PresentationsShell,
	};
</script>

<div class="app">
	<Toaster />
	<Router {routes} />
</div>

<style>
	:global(:root) {
		--primary-foreground: #333333;
		--primary-background: #fff;
		--active-foreground: #333;
		--active-background: #1576ee;
	}

	@font-face {
		font-family: "HeaderFont";
		font-style: normal;
		font-weight: 400;
		src:
			local("HeaderFont"),
			url("/font/Anton-Regular.ttf") format("truetype");
	}

	:global(html) {
		height: 100%;
	}

	:global(body) {
		font-family: "Inter", sans-serif;
		font-weight: 400;
		font-size: 16px;
		color: var(--primary-foreground);
		background-color: var(--primary-background);
		height: 100%;
	}

	:global(h1) {
		font-weight: 600;
		font-size: 1.5rem;
	}

	:global(h2) {
		font-weight: 600;
		font-size: 1.2rem;
	}

	:global(#app) {
		display: flex;
		flex-direction: row;
		justify-content: center;
		background-color: #aaa;
		min-height: 100%;
	}

	.app {
		width: 100%;
		background-color: var(--primary-background);
		min-height: 100%;
		position: relative;
		padding-bottom: 3rem;
		box-sizing: border-box;
		overflow: hidden;
	}
</style>
